export default __webpack_public_path__ + "static/media/014-dice.1cc5a4cd.svg";